import React from 'react';
import './style.scss';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const LogoListingCard = ({ data, className }) => {
  const { icon, title } = data.fields;

  return (
    <div className={clsx('ll-card', className)}>
      <Image field={icon} className="ll-card-image" />
      <h4 className="ll-card-title">
        <Text field={title} />
      </h4>
    </div>
  );
};

export default LogoListingCard;
